import { render, staticRenderFns } from "./index.vue?vue&type=template&id=913b3b2c"
import script from "./index.ts?vue&type=script&lang=js&external"
export * from "./index.ts?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=913b3b2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0___e99d8e97de94c5042a76fec31f8d8632/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports